import * as yup from 'yup';
import {EMAIL} from '@constants/subscription';
import {localize} from '@services/i18n';

export default yup.object().shape({
    [EMAIL]: yup
        .string()
        .required(window.wp.i18n.__('ValidationMessages_required', 'paperpress'))
        .matches(
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*[a-zA-Z0-9_]@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/,
            localize('ValidationMessages_email'),
        ),
});
